/* eslint-disable no-script-url */

import React from 'react'
import { makeStyles } from '@material-ui/core/styles'

import { Box } from '@material-ui/core'
import clsx from 'clsx'
import styleFckEditorarea from '../../assets/style/fck_editorarea.module.css'

const useStyles = makeStyles(theme => ({
  messageBox: {
    width: '100%',
    borderRadius: '4px',
    boxShadow:
      '0px 1px 3px 0px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 2px 1px -1px rgba(0,0,0,0.12);',
    '& .header': {
      backgroundColor: theme.palette.primary.light,
      borderRadius: '4px 4px 0 0',
      color: 'white'
    }
  },
  spacer: {
    marginLeft: '20px',
    height: '30px'
  },
  verticalLine: {
    borderLeft: 'solid 3px #bbb'
  },
  rawMessage: {
    width: '100%',
    margin: 0,
    fontSize: '14px' /* Mozilla */,
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-all',
    fontFamily: `'Robot', 'Hiragino Kaku Gothic', 'ヒラギノ角ゴシック', 'Hiragino Kaku Gothic ProN',
    'ヒラギノ角ゴ ProN W3', 'メイリオ', 'Osaka', 'ＭＳ Ｐゴシック', 'Helvetica Neue', 'Helvetica',
    'Arial', 'system-ui', 'sans-serif'`
  },
  read: {
    color: '#fff',
    border: 'none'
  },
  noRead: {
    backgroundColor: '#fff',
    border: 'none'
  },
  previewCssHeadline: {
    '& h2': {
      backgroundColor: '#38879c',
      fontWeight: 'bold',
      color: '#fff',
      fontSize: '16px',
      margin: 0,
      padding: '9px 10px 7px',
      lineHeight: '1.3em',
      display: 'flex',
      alignItems: 'center'
    },
    '& h3': {
      fontWeight: 'bold',
      // backgroundColor:
      //   'rgba(0, 0, 0, 0) linear-gradient(to bottom, #ffffff 0%, #e5e5e5 100%) repeat scroll 0 0',
      backgroundImage: 'linear-gradient(rgb(255, 255, 255) 0%, rgb(229, 229, 229) 100%)',
      backgroundRepeat: 'repeat',
      backgroundAttachment: 'scroll',
      backgroundColor: 'rgba(0, 0, 0, 0)',
      border: '1px solid #ccc',
      color: '#333',
      padding: '5px 5px 5px 15px'
    },
    '& h3 > a': {
      textDecoration: 'none',
      color: '#000000'
    },
    '& h5': {
      padding: '3px 5px',
      borderBottom: '1px dotted #2f6db3',
      backgroundColor: 'white',
      marginBlockStart: '1.67em',
      marginBlockEnd: '1.67em',
      marginInlineStart: '0px',
      marginInlineEnd: '0px',
      fontWeight: 'bold'
    },
    '& .shadowbox': {
      fontSize: '90%',
      margin: '10px auto',
      padding: '5px',
      border: 'solid gray',
      borderWidth: '1px 1px 1px 1px',
      backgroundColor: '#edf2fa'
    },
    fontFamily: `'Robot', 'Hiragino Kaku Gothic', 'ヒラギノ角ゴシック', 'Hiragino Kaku Gothic ProN',
    'ヒラギノ角ゴ ProN W3', 'メイリオ', 'Osaka', 'ＭＳ Ｐゴシック', 'Helvetica Neue', 'Helvetica',
    'Arial', 'system-ui', 'sans-serif'`
  }
}))

const DangerouslyBox: React.FC<{
  children: string
}> = ({ children }) => {
  const classes = useStyles({})

  return (
    <Box p={2}>
      <div
        className={clsx(
          `${styleFckEditorarea.item} ${styleFckEditorarea.new}`,
          classes.previewCssHeadline
        )}
        dangerouslySetInnerHTML={{ __html: children }}
      />
    </Box>
  )
}

export default DangerouslyBox
